import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { IntegrityMonitorDefaultRuleConfigurationDataProviderFactory } from '../factory/IntegrityMonitorDefaultRuleConfigurationDataProviderFactory';
import { IntegrityMonitorDefaultRuleConfigurationBaseDataProvider } from '../dataProvider/IntegrityMonitorDefaultRuleConfigurationBaseDataProvider';
import { IntegrityMonitorRuleGridItem } from '../../integrityMonitorRulesGrid/types';
import { IntegrityMonitorAssignationData } from '../types';

export class IntegrityMonitorDefaultRuleConfigurationRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IntegrityMonitorDefaultRuleConfigurationDataProviderFactory;
  public dataProvider: IntegrityMonitorDefaultRuleConfigurationBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IntegrityMonitorDefaultRuleConfigurationDataProviderFactory(),
    });
  }

  public async getRuleAssignationData(ruleSetIds: Array<string>): Promise<IntegrityMonitorAssignationData> {
    return this.dataProvider.getRuleAssignationData(ruleSetIds);
  }

  public async configureDefaultRule(ruleData: IntegrityMonitorRuleGridItem): Promise<Object | null> {
    return this.dataProvider.configureDefaultRule(ruleData);
  }
}
